import { Box } from "@mui/material";
import { useState } from "react";
import { ProductRequest } from "../../service/model/store.model";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import * as productSlice from "../../features/store/products/product.slice";
import Loader from "../../components/loader";
import useProducts from "../../hooks/use-products";
import { selectLoggedInUser } from "../../features/auth/auth.slice";
import ProductTable from "../../features/store/products/components/product-table";
import ProductForm from "../../features/store/products/components/product-form";
import ProductSummary from "../../features/store/products/components/product-summary";
import CreateButton from "../../components/create-button";

const Products = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showProductForm, setShowProductForm] = useState(false);
    const isLoading = useAppSelector(productSlice.selectIsLoading);

    const [products] = useProducts();

    const handleSubmit = (data: ProductRequest) => {
        loggedInUser && dispatch(productSlice.createProduct({ ...data, })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowProductForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {products &&
                <>
                    <ProductSummary />
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowProductForm(true)} style={{ marginBottom: "12px" }}>Add Product</CreateButton>
                    </Box>
                    <ProductTable products={products} />
                    {showProductForm &&
                        <ProductForm product={undefined} editable={true} onClose={() => setShowProductForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Products;